import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export type EditDeviceDetailedMutationParams = {
	id: number;
	name: string;
};

export const createEditDeviceDetailedMutation = () =>
	createAuthMutation({
		params: declareParams<EditDeviceDetailedMutationParams>(),
		request: {
			method: 'PATCH',
			url: (params) => `/device/details/${params.id}`,
			body: (data) => ({
				name: data.name,
			}),
		},
		response: {
			contract: zodContract(entityWithNameSchema),
		},
	});
